import { render } from "./ClientAuthorizedRemoveScopeModal.vue?vue&type=template&id=539d032a"
import script from "./ClientAuthorizedRemoveScopeModal.vue?vue&type=script&lang=js"
export * from "./ClientAuthorizedRemoveScopeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__